import { render, staticRenderFns } from "./approval-list.vue?vue&type=template&id=abb0a7fe&"
import script from "./approval-list.vue?vue&type=script&lang=ts&"
export * from "./approval-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports